import type { VoidFunctionComponent } from 'react';

import FeatureComparison from './features';
import { PlanSelector } from './PlanSelector';

const CurrentPlanContent: VoidFunctionComponent = () => {
  return (
    <div className="current-plan-container">
      <PlanSelector />
      <FeatureComparison />
    </div>
  );
};

export default CurrentPlanContent;
